import { useNavigate } from "react-router-dom";
import { CategoryType } from "../../../types/Library";
import { useMutation } from "react-query";
import { createCategory } from "../../../services/library/category";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CategoryFormValidation } from "./CategoryFormValidation";
import toast from "react-hot-toast";
import { routes } from "../../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";

export const CreateCategory = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: createCategory, mutationKey: 'createCategory' });
    const defaultValues:CategoryType={
        description: ""
    }
    const { control, handleSubmit, formState: { errors } , setValue , watch} = useForm<CategoryType>
    (
      {
        resolver: yupResolver(CategoryFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
    const onSubmit = handleSubmit(async (data) => {
        try {
          const result = await mutation.mutateAsync(data);
          if (result) {
            toast.success("Criada com sucesso!");
            navigate(routes.categories);
          }
        } catch (err: any) {
          toast.error(`${mutation.error ?? err?.message}`);
        }
      });
      const handleBack = () => {
        navigate(routes.categories);
    }

   return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
       
          <Flex direction='row' gap='4'>
            <TextFieldComponent name="description" label="Categoria" control={control} errors={errors} fieldProps={{ placeholder: 'Categoria'}}  style={{ width: '100%' }} required={true}/>
         </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant='soft' color='gray' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading /> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
